import parseJSON from '../parseJSON';

const session = 'sessionStorage';
const local = 'localStorage';
const cookie = 'cookie';
const storageType = {
  session,
  session_portal: cookie,
  session_local: session,
  session_portal_local: cookie,
  remember_me_local: cookie,
  publisher_cookie_local: cookie,
  session_dev: session,
  session_portal_dev: cookie,
  remember_me_dev: cookie,
  publisher_cookie_dev: cookie,
  session_stg: session,
  session_portal_stg: cookie,
  remember_me_stg: cookie,
  publisher_cookie_stg: cookie,
  favoritesLoaded_stg: session,
  remember_me: cookie,
  refreshMKTGConsent: local,
  publisherCookie: cookie,
  favoritesLoaded: session,
  favorites: local,
  searches: local,
  accountSigninName: local,
  userSettings: session,
  tempFormData: session,
  hintTooltipSaveSearch: local,
};

const getCookieDomain = () => {
  const hostParts = window.location.hostname.split('.');
  if (hostParts.indexOf('localhost') > -1) { // local
    return '';
  } if (hostParts.indexOf('dev') > -1) { // dev environment
    return `;domain=.${hostParts.slice(hostParts.indexOf('dev')).join('.')}`;
  } if (hostParts.length > 2) { // prod environment
    return `;domain=.${hostParts.slice(hostParts.length - 2).join('.')}`;
  }
  return '';
};

export function setCookie(cname, cvalue, exdays, { expiresDateRememberMe } = {}) {
  let d = new Date();
  let expires = exdays === 0 ? 'expires=0' : `expires=${d.toUTCString()}`;
  if (expiresDateRememberMe) {
    d = new Date(expiresDateRememberMe);
    expires = `expires=${d.toUTCString()}`;
  } else {
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    expires = exdays === 0 ? 'expires=0' : `expires=${d.toUTCString()}`;
  }
  const domain = getCookieDomain();

  document.cookie = `${cname}=${cvalue}; ${expires}; path=/ ${domain}`;
}

export function getCookie(cname) {
  const name = `${cname}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

export function setItem(key, value, { expiresDateRememberMe } = {}) {
  if (!window) {
    return;
  }
  switch (storageType[key]) {
    case session:
      window.sessionStorage.setItem(key, value);
      break;
    case cookie:
      setCookie(key, value, 30, { expiresDateRememberMe });
      break;
    default:
      window.localStorage.setItem(key, value);
  }
}

export function getItem(key) {
  if (!window) {
    return null;
  }
  switch (storageType[key]) {
    case session:
      return window.sessionStorage.getItem(key);
    case cookie:
      return getCookie(key);
    default:
      return window.localStorage.getItem(key);
  }
}

export const getFormData = (userFormData = {}) => {
  let lsFormData = {};
  const formDataOld = parseJSON(getItem('formData'));
  const signinData = parseJSON(getItem('signinData'));
  if (formDataOld) {
    lsFormData = formDataOld;
    if (signinData && signinData.formData && Object.keys(signinData.formData).length) {
      localStorage.removeItem('formData');
    }
  } else if (signinData) {
    const { formData } = signinData;
    lsFormData = formData;
  }
  return lsFormData || userFormData;
};

export const fillFormData = (fd, ud) => {
  const nfd = { ...fd };
  let consent = false;

  if (
    ud.consents
    && Object.keys(ud.consents).length > 0
    && Object.keys(ud.consents).includes('1')
  ) {
    consent = ud.consents['1'];
  }

  nfd.email = ud.email;
  nfd.firstName = ud.displayname;
  nfd.lastName = '';
  nfd.name = ud.displayname;
  nfd.telephone = ud.phone;
  nfd.consent = consent;
  return nfd;
};
